import { Checkbox } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function SelectedTask({ task, ...props }) {
    const { selectedTasks, setSelectedTasks } = useBoundContext()
    return (
        <Checkbox
            data-cy="select-similar-task-check-box"
            size="small"
            sx={{ p: 0 }}
            checked={!!selectedTasks[task.id]?.[0]}
            onChange={toggle}
            {...props}
        />
    )

    function toggle() {
        setSelectedTasks((tasks) => {
            const updated = { ...tasks }
            if (updated[task.id]) delete updated[task.id]
            else updated[task.id] = [true, task]
            return updated
        })
    }
}
